import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://jmardg.com";
const SITE_NAME = "Jamia Mohammadia Arabia";
const DEFAULT_DESCRIPTION =
  "Jamia Mohammadia Arabia (JMA) is a leading Islamic educational institution in Rayadurg, Andhra Pradesh, offering Arabic, Islamic studies, and modern education.";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

export default function SEO({ title, description, path = "", image }) {
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Mohammadiya Arabic College, Rayadurg`;
  const metaDescription = description || DEFAULT_DESCRIPTION;
  const metaImage = image || DEFAULT_IMAGE;
  const normalizedPath = path && !path.startsWith("/") ? `/${path}` : path;
  const canonical = `${SITE_URL}${normalizedPath}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
}
